import logo from "./assets/images/common/logo.svg";
export const PROJECT_NAME = "Giant Spell";
export const PROJECT_META_NAME = "giant_spell";
export const ENVIRONMENT = "development"; //production | development
export const TOKEN_KEY =
  ENVIRONMENT === "development"
    ? `_${PROJECT_META_NAME}_token`
    : `_${PROJECT_META_NAME}_token_dev`;

export const IDLE_TIME_IN_SECONDS = 300;

export const LOGO = logo;
